import React from 'react'
import LoanCalculation from '../initial-loan-process/screen/loan-calculation'

const RefinanceRequest = () => {
  return (
    <LoanCalculation/>
  )
}

export default RefinanceRequest